import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import UploadList from './UploadList';

const mapStateToProps = (state, ownProps) => ({
    accountId: state.currentAccountId,
    uploads: state.uploads,
});

export default withRouter(
    connect(mapStateToProps)(UploadList)
);
